import React from "react";
import HeroHeader from "../../components/heroHeader/HeroHeader";
import AboutUsSection from "../../components/aboutUsSection/AboutUsSection";
import "./Homepage.css";
import GridShowcase from "../../components/gridShowcase/GridShowcase";
import Carousel from "../../components/carousel1/Carousel1";
import Carousel3 from "../../components/carousel3/Carousel3";
import Testimonials from "../../components/testimonials/Testimonials";
import FeaturedSection from "../../components/featuredSection/FeaturedSection";
import Gallery from "../../components/gallery/Gallery";

const Homepage = () => {
  return (
    <div>
      <HeroHeader />
      <AboutUsSection />
      <GridShowcase />
      <Carousel />
      <Carousel3 />
      <FeaturedSection />
      <Gallery />
      <Testimonials />
    </div>
  );
};

export default Homepage;
